import { render, staticRenderFns } from "./RealmSelect.vue?vue&type=template&id=49dfc5ce&scoped=true&"
import script from "./RealmSelect.vue?vue&type=script&lang=js&"
export * from "./RealmSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfc5ce",
  null
  
)

export default component.exports